import { getSavedSceneCameraPickUuid } from "../../scene/savedCameraMarker";
import { getSavedSceneLightPickUuid } from "../../scene/savedLightMarker";

function isVisualMeshForPicker(obj, { isCollisionGeomObject, getJointIdFromObject, requireColor }) {
  if (
    !obj.isMesh ||
    isCollisionGeomObject(obj) ||
    obj.userData.isJointEndpoint ||
    getJointIdFromObject(obj) ||
    obj.userData.isInertial ||
    (obj.userData && obj.userData.type === "inertial")
  ) {
    return false;
  }

  if (requireColor && (!obj.material || !obj.material.color)) {
    return false;
  }

  if (obj.material?.color?.getHex() === 0xff2222) return false;
  if (obj.material?.color?.getHex() === 0xffff00) return false;
  return true;
}

export function filterScenePickerIntersects(
  intersects,
  {
    focusBodiesGateSet,
    getJointIdFromObject,
    getOwningBodyUuidForObject,
    isCollisionGeomObject,
    requireVisualMeshColor = false,
    showCollision,
    showSavedCameraMarkers,
    showVisual,
  }
) {
  return intersects.filter((intersect) => {
    const obj = intersect.object;

    if (!obj.visible) return false;
    if (obj?.userData?.isActuatorVisualization) return true;
    if (obj?.userData?.isConstraintVisualization) return false;
    if (obj?.userData?.isJointSelectionHighlightSphere) return false;
    if (obj?.userData?.isJointSelectionGlowOnly) return false;
    if (
      obj?.userData?.isPositionGizmo ||
      obj?.userData?.isRotationGizmo ||
      obj?.userData?.isScaleGizmo
    ) {
      return false;
    }
    if (!showCollision && isCollisionGeomObject(obj)) return false;
    if (obj.name === "sceneFloor" || obj.name === "sceneGrid" || obj.userData.isGlow) {
      return false;
    }

    if (getSavedSceneCameraPickUuid(obj)) {
      return !!showSavedCameraMarkers;
    }
    if (getSavedSceneLightPickUuid(obj)) {
      return true;
    }

    if (obj.userData && (obj.userData.isInertial || obj.userData.type === "inertial")) {
      if (focusBodiesGateSet) {
        const bodyUuid = getOwningBodyUuidForObject(obj);
        return !!(bodyUuid && focusBodiesGateSet.has(bodyUuid));
      }
      return true;
    }

    if (
      isVisualMeshForPicker(obj, {
        getJointIdFromObject,
        isCollisionGeomObject,
        requireColor: requireVisualMeshColor,
      })
    ) {
      if (!showVisual) return false;
      if (focusBodiesGateSet) {
        const bodyUuid = getOwningBodyUuidForObject(obj);
        return !!(bodyUuid && focusBodiesGateSet.has(bodyUuid));
      }
      return true;
    }

    if (focusBodiesGateSet) {
      const bodyUuid = getOwningBodyUuidForObject(obj);
      return !!(bodyUuid && focusBodiesGateSet.has(bodyUuid));
    }
    return true;
  });
}
